export const SIGN_OUT = 'SIGN_OUT'
